// extracted by mini-css-extract-plugin
module.exports = {"modal":"OrdersInvoicesModal_modal__d2yxQ","entry":"OrdersInvoicesModal_entry__iB_Go"};